define('viewModels/privileged/qm/policies/editors/WrapupCodeSelectorView',[
    'lib/lodash4',
    'lib/knockout',
    'jquery',
    'viewModels/ViewModel',
    'services/queueAdmin/wrapupCodeService',
    'services/featureToggleService',

    // No references
    'extensions/i18n/knockout.i18n',
    'extensions/knockout.validation.extender',
    'lib/knockout.validation'
], function (_, ko, $, ViewModel, wrapupCodeService, featureToggleService) {
    'use strict';
    var WrapupCodeSelectorView = ViewModel.extend(function(wrapUpCodesObservable, options){

        var self = this;

        self.wrapUpCodes = wrapUpCodesObservable;

        self.placeholderText = ko.i18n.renderString('wrapUpCodeSelector.placeholderText');

        self.getWrapUpCodes = function (searchTerm) {
            var query = { pageSize: 10 };

            if (searchTerm && searchTerm.length > 0) {
                query.name = '*' + searchTerm.trim() + '*';
            }
            return featureToggleService.getFeatureToggle('assignment.divisionAwareWrapupCodes').then(function (isDivisionAware) {
                if (!isDivisionAware) {
                    return wrapupCodeService.getWrapupCodes(query).then(function (codes) {
                        var filteredCodes = codes.entities;

                        //Removes ignored wrapUpCodes if specified.
                        if (options && options.ignoredIds) {
                            _.remove(filteredCodes, function(code) {
                                return _.includes(options.ignoredIds(), code.id);
                            });
                        }

                        return _.map(filteredCodes, function (code) {
                            return {
                                id: code.id,
                                name: code.name
                            };
                        });
                    });
                } else {
                    return wrapupCodeService.getWrapupCodesForAllDivisions(query).then(function (codes) {
                        var filteredCodes = codes.entities;

                        //Removes ignored wrapUpCodes if specified.
                        if (options && options.ignoredIds) {
                            _.remove(filteredCodes, function(code) {
                                return _.includes(options.ignoredIds(), code.id);
                            });
                        }

                        return _.map(filteredCodes, function (code) {
                            return {
                                id: code.id,
                                name: code.name
                            };
                        });
                    });
                }
            });
        };

        if (_.isArray(self.wrapUpCodes())) {
            self.wrapUpCodes.extend({deepComparer: true, minLength: {params: 1, message: "wrapUpCodeSelector.noCodeSelected"}});
        } else {
            self.wrapUpCodes.extend({required: true});
        }

    }, true /* pass args to extended class */);
    return WrapupCodeSelectorView;
});

